<template>
    <div class ="lLoading" :style="{display:Display }">
      <img :style="{maxWidth:maxWidth}" :src="require('./img/'+image)" />
    </div>
</template>
<style src="./lLoading.css">
</style>
<script src="./lLoading.js">
</script>
